'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _components = require('../../../components');
var _containers = require('../../../containers');
var _OutlineNavigation = require('./OutlineNavigation.scss');var styles = _interopRequireWildcard(_OutlineNavigation);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

OutlineNavigation = function (_Component) {_inherits(OutlineNavigation, _Component);function OutlineNavigation() {var _temp, _this, _ret;_classCallCheck(this, OutlineNavigation);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      activeStepId: null,
      activeStepIdx: null }, _this.


    onSetActive = function (id) {
      if (id !== _this.state.activeStepId) {
        var idx = _this.props.navigationItems.findIndex(function (item) {return item.id === id;});

        _this.setState({ activeStepId: id, activeStepIdx: idx });
      }
    }, _this.

    setInactive = function () {return _this.setState({
        activeStepId: null,
        activeStepIdx: null });}, _this.


    renderSteps = function () {var
      activeStepIdx = _this.state.activeStepIdx;
      var activeId = activeStepIdx || activeStepIdx === 0 ? activeStepIdx : -1;
      var steps = activeId + 1 + '/' + _this.props.navigationItems.length;

      return (
        _react2.default.createElement('div', { className: styles.steps }, _this.props.translate('steps').toUpperCase(), ' ', _react2.default.createElement('span', null, steps)));

    }, _temp), _possibleConstructorReturn(_this, _ret);}OutlineNavigation.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.outlineWrapper },
        this.renderSteps(),
        _react2.default.createElement(_components.PublishPropertyOutlineNavigation, {
          navigationItems: this.props.navigationItems,
          onSetActive: this.onSetActive,
          onSetInactive: this.setInactive,
          activeStepId: this.state.activeStepId }),

        _react2.default.createElement(_containers.PropertyCellDynamicPreview, {
          routeData: this.props.routeData })));



  };return OutlineNavigation;}(_react.Component);


OutlineNavigation.propTypes = {
  translate: _propTypes2.default.func,
  navigationItems: _propTypes2.default.array,
  isMobile: _propTypes2.default.bool,
  routeData: _propTypes2.default.object };exports.default =


OutlineNavigation;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/OutlineNavigation/OutlineNavigation.js
// module id = 2997
// module chunks = 0